module.exports = __webpack_public_path__ + "img/pencil.062bd256.svg";